import React, { FC, useCallback } from 'react';
import { Link as RouterLink, LinkProps, useNavigate } from 'react-router-dom';

interface HashLinkProps extends LinkProps {
    smooth?: boolean;
}

export const HashLink: FC<HashLinkProps> = ({ smooth, onClick, to, ...rest }) => {
    const navigate = useNavigate();

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            if (onClick) {
                onClick(e);
            }
            if (e.defaultPrevented) return;

            e.preventDefault();

            const toStr = typeof to === 'string' ? to : `${to.pathname || ''}${to.search || ''}${to.hash || ''}`;
            navigate(toStr);

            const hashIndex = toStr.indexOf('#');
            if (hashIndex !== -1) {
                const hash = toStr.substring(hashIndex + 1);
                requestAnimationFrame(() => {
                    const element = document.getElementById(hash);
                    if (element) {
                        element.scrollIntoView(smooth ? { behavior: 'smooth' } : undefined);
                    }
                });
            }
        },
        [navigate, onClick, smooth, to],
    );

    return <RouterLink to={to} onClick={handleClick} {...rest} />;
};
